
import { useLanguagePath } from "@/utils/language";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/landing/Footer";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useTranslations } from "@/hooks/useTranslations";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Home } from "lucide-react";
import { useEffect, useState } from "react";

// Função utilitária para parágrafos automáticos
function autoParagraph(html: string): string {
  const hasBlocks = /<\/(p|ul|ol|li|table|tr|td|th|h[1-6])>/i.test(html);
  if (hasBlocks) return html;
  return html
    .split(/\n{2,}/g)
    .map((para) => `<p>${para.replace(/\n/g, "<br/>")}</p>`)
    .join("");
}

// Função para transformar marcadores [1. Título] e **Título** em <h2>
function formatHeadings(html: string): string {
  // Headings numéricos tipo "1. Título"
  html = html.replace(/^(\d+\.\s+)([^\n]+)/gm, (_match, _num, title) => `<h2 class="font-semibold mb-4">${title}</h2>`);
  // Headings em markdown **Título**
  html = html.replace(/^\*\*([^\n*]+)\*\*$/gm, (_match, title) => `<h2 class="font-semibold mb-4">${title}</h2>`);
  return html;
}

const Privacy = () => {
  const { getPath } = useLanguagePath();
  const { t, loading } = useTranslations("privacy");
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    if (!loading) {
      let content = t("html");
      if (content && typeof content === "string") {
        content = formatHeadings(content);
        setHtmlContent(autoParagraph(content));
      }
    }
  }, [t, loading]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-gray-900 dark:to-gray-950">
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/")}>
                <Home className="h-4 w-4" />
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{t("title")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <h1 className="text-3xl font-bold text-center mb-8">{t("title")}</h1>
        <ScrollArea className="h-[60vh] md:h-[70vh] rounded-md border p-4 md:p-6 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm">
          {loading ? (
            <div className="flex justify-center items-center h-full">
              <p>Carregando...</p>
            </div>
          ) : htmlContent ? (
            <div
              className="prose dark:prose-invert prose-headings:font-bold prose-headings:text-gray-900 dark:prose-headings:text-white prose-p:text-gray-700 dark:prose-p:text-gray-300 prose-li:text-gray-700 dark:prose-li:text-gray-300 max-w-none"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          ) : (
            <div className="text-center p-4">
              <p>Não foi possível carregar a política de privacidade.</p>
            </div>
          )}
        </ScrollArea>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
